import React from 'react';

import InstructionModalTemplate from '../../../../components/DataDisplay/InstructionModalTemplate';
import SupportAndStoreTemplate from '../../../../components/SupportAndStoreTemplate/SupportAndStoreTemplate';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import connectivityService from '../../../../services/device/connectivityService';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';

const CriticalReconnectGuide = (props) => {
    const {guideData, hideModalGuide} = props;
    const {header, reconnectStepListBle, reconnectStepListUsb} = guideData;
    const localizedStrings = getLocalizedStrings();
    const isBle = connectivityService.isBle();
    const reconnectStepList = isBle ? reconnectStepListBle : reconnectStepListUsb;

    return (
        <InstructionModalTemplate
            className='mx-auto w-full py-10'
            subTitleKey={localizationKeys.IO_ERROR_SUB_TITLE_TEXT}
            instructionList={reconnectStepList}
            articleProps={{
                titleKey: header,
                className: 'lg:max-w-[724px]',
                error: true,
            }}
            instructionButtonProps={{
                primary: true,
                light: true,
                className: 'w-full mt-10 sm:min-w-[312px] md:w-auto',
                onClick: hideModalGuide,
                children: localizedStrings[localizationKeys.IO_ERROR_TRY_AGAIN_BUTTON_TEXT],
            }}
        >
            <SupportAndStoreTemplate isTitleVisible />
        </InstructionModalTemplate>
    );
};

export default CriticalReconnectGuide;
